import type { MatrixBucket, MatrixMilestoneState } from "./workloadMatrix";
import type { MissionStepOwnerRole } from "./annualReviewMission";

export type CoverageMatrixCellDetail = {
  title: string;
  statusLabel: string;
  clientName?: string;
  taskTitle?: string;
  assigneeName?: string;
  assigneeRole?: MissionStepOwnerRole;
  assigneeIsAgent?: boolean;
  /** When true, show a message field to nudge the assignee. */
  canMessage?: boolean;
  messagePlaceholder?: string;
};

export const MILESTONE_STATUS_LABELS: Record<MatrixMilestoneState, string> = {
  none: "Not started",
  done: "Complete",
  chasing: "Urgent — needs attention",
  due: "Due",
  stale: "Stale",
  decide: "Needs your decision",
};

export const BUCKET_STATUS_LABELS: Record<MatrixBucket, string> = {
  done: "Cleared",
  due: "Due",
  chasing: "Chasing",
  stale: "Stale",
};

export function ownerRoleLabel(role: MissionStepOwnerRole): string {
  switch (role) {
    case "adviser":
      return "Adviser";
    case "paraplanner":
      return "Paraplanner";
    case "administrator":
      return "Administrator";
    case "agent":
      return "Agent";
  }
}
